import {EmbedCodeExtractor} from "./types"

/** Patterns of Tik::WebEmbedService::PreProcessor::Opinary (pre_processor/opinary.rb). */
const PATTERNS = [
  /class="opinary-widget-embed".*data-poll="([a-zA-Z0-9_-]+)"/i
]

/**
 * Converts Opinary `<div class="opinary-widget-embed" ... data-poll="<id>">` embed code
 * to the canonical `https://compass.pressekompass.net/compasses/mach/<id>` URL.
 */
export const opinaryPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      return `https://compass.pressekompass.net/compasses/mach/${match[1]}`
    }
  }
  return null
}
